export default __webpack_public_path__ + "static/content-1-l5-img-fcd7b9076471f22ec4c824bbabcaaa17.png";